import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as WebHookActions from '../../features/webhook-actions'
import * as WebHookSelectors from '../../features/webhook-selectors'
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { loadWebHookList } from '../../features/webhook-actions';
import { DataTableDirective } from 'angular-datatables';
import { ADTSettings } from 'angular-datatables/src/models/settings';
import { FailedTransactionsActionCellComponent } from '../failed-transactions-action-cell/failed-transactions-action-cell.component';
import { WebHookFormModalService } from '../../services/web-hook-form-modal/web-hook-form-modal.service';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
  selector: 'app-webhook-details-list',
  templateUrl: './webhook-details-list.component.html',
  styleUrl: './webhook-details-list.component.scss',
  providers: [CurrencyPipe, DatePipe],
})
export class WebhookDetailsListComponent implements OnInit,OnDestroy{
  @Input() id:string | null;
  private takeUntilSubject$:Subject<any> = new Subject();
  public selectedWebHook:any;
  public failedTransactions: any[];
  constructor(
    private store:Store,
    private activatedRoute:ActivatedRoute,
    public router: Router,
    private webHookModalService:WebHookFormModalService,
    private currencyPipe:CurrencyPipe,
    private datePipe:DatePipe
  )
  {}

  private webHookListSelector$ = this.store.pipe(
    select(WebHookSelectors.selectWebHookList$)
  )

  private failedTransactionsSelector$ = this.store.pipe(
    select(WebHookSelectors.selectFailedTransactions$)
  )

  ngOnInit(): void {
    this.store.dispatch({
      type: loadWebHookList.type
    });

    this.id = this.activatedRoute.snapshot.paramMap.get('id')

    this.store.dispatch(
      WebHookActions.loadFailedTransactions({ webHookId: this.id})
    );

    this.webHookListSelector$.pipe(
      takeUntil(this.takeUntilSubject$)
    ).subscribe(list =>{
      this.selectedWebHook = list?.find(x => x.id === this.id);
    })

    this.failedTransactionsSelector$.pipe(
      takeUntil(this.takeUntilSubject$)
    ).subscribe(list => {
      this.failedTransactions = list;
      this.renderDataTable();
    })
  }

  ngOnDestroy(): void {
    this.takeUntilSubject$.next(null);
    this.takeUntilSubject$.complete();
  }


  onEdit(){
    this.webHookModalService.editOrAddWebHook(this.selectedWebHook)
  }

  onDelete(){
    this.webHookModalService.onConfirmDelete(`Are you sure?`, `You want to delete this webhook.`, () => {
            this.store.dispatch(
              WebHookActions.deleteWebHook({ webHookId: this.selectedWebHook?.id, onDetailsPage:true })
            )
        });
  }

  onTestSend(){
    this.store.dispatch(
      WebHookActions.testSendWebHook({webHookId:this.selectedWebHook?.id})
    )
  }

  onTabChange(event){
    if(event.target != 0){
      return;
    }
  }

  @ViewChild(DataTableDirective, {static: false})
  public dtElement: DataTableDirective;
  
  public dtOptions: ADTSettings = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  ngAfterViewInit(): void {
    this.renderDataTable();
  }

  @ViewChild('webHookActionCell') webHookActionCell: TemplateRef<FailedTransactionsActionCellComponent>;
  

  renderDataTable(){
    this.dtOptions = {
      data:this.failedTransactions,
      dom: "<'table__header--paybee d-flex align-items-center justify-content-between pb-3 pt-3'<''B><''f>><'table-responsive't><'table__footer--paybee d-flex align-items-center justify-content-between p-4'ip>",
      buttons: [{
          className: 'btn-copy-code btn btn-outline-grey btn-sm px-2 waves-effect',
          extend: 'excel',
          filename: 'integrationMonkeyList',
          text: "<i class='fas fa-cloud-download-alt cursor--pointer mr-1'></i><span class='cursor--pointer'>Export</span>",
          title: null,
          exportOptions: {
              stripHtml: true,
              columns: "thead th:not(.no-export)"
          }
      }],
      columns: [
        {
          data: "event_type",
        },
        {
          data: "created",
          render: (data: any) => this.datePipe.transform(data, 'medium')
        },
        {
          data: "error_code",
        },
        {
          data: "error_msg",
        },
        {
          data: "last_retried",
          render: (data: any) => this.datePipe.transform(data, 'medium')
        },
        {
          data: "retry_count",
        },
        {
          data: "transaction.amount",
          render: (data: any) => this.currencyPipe.transform(data, 'USD', 'symbol-narrow', '1.0-0')
        },        
        {
          data: null,
          orderable:false,
          defaultContent: '',
          ngTemplateRef: {
            ref: this.webHookActionCell,
          }
        }
      ],
      destroy: true
    }

    setTimeout(() => {
      // race condition fails unit tests if dtOptions isn't sent with dtTrigger
      if (!this.dtTrigger.closed) {
        this.dtTrigger.next(this.dtOptions);
      }
    }, 200);
  }
}
